import React, {Component} from 'react';
import Axios from 'axios';
import connect from "react-redux/es/connect/connect";
import moment from "moment";


class EmbedPlayer extends Component {
    constructor (props) {
        super (props);

        console.log('props : ', props);

        this.state = {
            name:"",
            mediaFormat:"",
            thumbnailUrl:"",
            description:"",
            videoUrl:"",
            jobId:""
        };

        // this.state.videoId = this.props.match.params.videoId;
        this.state.videoId = this.props.match && this.props.match.params && this.props.match.params.id;

        // this.state.videoId= '944912477nG89L';

        // console.log("SharedVideoDetail");
        // this.setInitialState();
        console.log("SharedVideoDetail videoId : ", this.state.videoId);
    }

    componentDidMount = async () =>{
        console.log("SharedVideoDetail componentDidMount ", this.state);
        await this.setInitialState();

        // var _function = ('cloudplex-media-player').replace(/^[A-Z]/, function(m) {
        //     m.toLowerCase();
        //   });
        
          var player = window.player = window.CloudPlexPlayer('cloudplex-media-player',
          {
			theme: 'default',						
			muted: true,
			autoplay: true,										
		});
        
        
        console.log("_function: ", player);

        player.src([{
            src: this.state.videoUrl,
            type: this.state.mimeType,
            thumbnail: this.state.thumbnailUrl,
            meta: {
                "video-id": this.state.videoId
            },
            descriptionDetail: {
                title: this.state.name,
                content: this.state.description,
            },
            title: this.state.name,
            subTitle: "",
            description: this.state.description,           
            poster: this.state.thumbnailUrl,
            prev: {
                link: ""
            }
        }]);
        
        //   var player = window.player = window[_function]('cloudplex-media-player',
        //     window.playerOptions);
  

        console.log("window: ", window);
    }

    deparam = (search) => {
        if(!search || search.trim().length === 0) {
            return null;
        }
    
        if(search.indexOf('?') === 0) {
            search = search.slice(1);
        }
    
        const params = search.split('&');
        if(params.length === 0) {
            return null;
        }
    
        const result = {};
        params.forEach(p => {
            const param = p.split('=');
    
            result[param[0]] = param[1];
        });    
        
        return result;
    };


    getVideo = async () => {
        try {
            console.log("getVideo");

            if (this.state.videoId && this.state.videoId.length === 0) {
                return null;
            }

            const apiEndPoint = 'https://9kf3tg0nsd.execute-api.ap-northeast-2.amazonaws.com/dev';

            console.log("getVideo 1 ");
            const response = await Axios.get(`${apiEndPoint}/videos/${this.state.videoId}/social/shared/`, {            
            });

            console.log("getVideo 2");
            const video = response.data;
            const videoSource = video.sources && video.sources.length > 0 && video.sources[0];

            return {
                id : video.id,
                name : video.name,
                mediaFormat : videoSource && videoSource.type && videoSource.type.toLowerCase(),
                description : video.description === null || video.description === 'undefined' ? "empty" : video.description ,
                videoUrl : videoSource && videoSource.urls && videoSource.urls.length > 0 && videoSource.urls[0],
                thumbnailUrl : video.primaryPoster && video.primaryPoster.url,
                jobId : video.job && video.job.id,
                duration : video.duration 
            };
        } catch(e) {
            throw e;
        }
    }
   
    setInitialState = async () => {
        try {
            const video =  await this.getVideo();

            console.log("setInitialState() : ", JSON.stringify(video));

            let mimeType = '';
            switch((video.mediaFormat || '').toLowerCase()) {
                case 'hls':
                    mimeType = 'application/x-mpegURL';
                    break;
                case 'dash':
                    mimeType = 'application/dash+xml';
                    break;
                case 'mp4':
                    mimeType = 'video/mp4';
                    break;
                case 'ts':
                    mimeType = 'video/MP2T';
                    break;
                case 'mp3':
                    mimeType = 'audio/mp3';
                    break;
                default:
                    break;
            }            

            this.setState( {
                name : video.name,
                mediaFormat : video.mediaFormat,
                mimeType,
                description : video.description,
                videoUrl : video.videoUrl,
                thumbnailUrl : video.thumbnailUrl,
                jobId : video.jobId,
                duration : video.duration
            });

            console.log("setInitialState() : ", JSON.stringify(this.state));

        } catch(e) {
            this.setState({
                pending : false,
                error : true
            });
        }
    }

    formatDuration = (milliseconds, timeFormat) => {
        console.log("formatDuration milliseconds: ", milliseconds)
        if(!milliseconds) {
            return '00:00:00';
        }
    
        if (!timeFormat) {
            timeFormat = 'HH:mm:ss';
        }

        const result = moment.utc(milliseconds).format(timeFormat);
        
        console.log("formatDuration result : ", result)

        return moment.utc(milliseconds).format(timeFormat);
    };

    render = () => {
        return (
            <div className={"content-wrapper"}>              
                <div className="vjs-player">
			        <video id="cloudplex-media-player" className="video-js" controls></video>
		        </div>
            </div>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        state        
    };
};

EmbedPlayer = connect(mapStateToProps)(EmbedPlayer);
export default EmbedPlayer;